import axios from 'axios';

export const moduleDictionaries = {
	state() {
		return {
			documentsType: null,
			countries: null,
			province: null,
			taxCities: null,
			taxAddresses: null,
			//Loader
			addresDictionaryLoader: false,
			taxDictionaryLoader: false,
		};
	},
	mutations: {
		setDocumentsType(state, data) {
			state.documentsType = data;
		},
		setCountries(state, data) {
			state.countries = data;
		},
		setProvince(state, data) {
			state.province = data;
		},
		setTaxCities(state, data) {
			state.taxCities = data;
		},
		setTaxAddresses(state, data) {
			state.taxAddresses = data;
		},
		//Loader
		setAddresDictionaryLoader(state, data) {
			state.addresDictionaryLoader = data;
		},
		setTaxDictionaryLoader(state, data) {
			state.taxDictionaryLoader = data;
		},
	},
	getters: {
		getDocumentsType: (state) => state.documentsType,
		getCountries: (state) => state.countries,
		getProvince: (state) => state.province,
		getTaxCities: (state) => state.taxCities,
		getTaxAddresses: (state) => state.taxAddresses,
		//Loader
		getAddresDictionaryLoader: (state) => state.addresDictionaryLoader,
		getTaxDictionaryLoader: (state) => state.taxDictionaryLoader,
	},
	actions: {
		fetchAddressDictionary({ commit, dispatch }) {
			commit('setAddresDictionaryLoader', true);
			dispatch('newLogoutTime');
			axios
				.get('Dictionary/GetAddressDict')
				.then((response) => {
					commit('setDocumentsType', response.data.documentTypes);
					commit('setCountries', response.data.countries);
					commit('setProvince', response.data.province);
				})
				.catch(() => {})
				.finally(() => {
					commit('setAddresDictionaryLoader', false);
				});
		},
		fetchTaxDictionary({ commit, dispatch }) {
			commit('setTaxDictionaryLoader', true);
			dispatch('newLogoutTime');
			new Promise((resolve) => {
				axios
					.get('Dictionary/GetTaxDict')
					.then((response) => {
						commit('setTaxCities', response.data.cityTax);
						commit('setTaxAddresses', response.data.addressTax);
						resolve();
					})
					.catch(() => {})
					.finally(() => {
						commit('setTaxDictionaryLoader', false);
					});
			});
		},
		changeTaxCountry({ commit, dispatch }) {
			commit('setTaxCityId', 705);
			dispatch('fetchTaxDictionary').then(() => {
				commit(
					'setTaxOfficeId',
					171
				); /* III Urz.Sk. Warszawa-Śródmieście - siedziba podległa (Lindleya 16, 02-013 WARSZAWA)*/
			});
		},
	},
};
